/** Checklist page where long-press / selection translate is enabled. */
export const SPANISH_TRANSLATE_PAGE_PATH = 'database/spanish.md';

export function isSpanishTranslatePage(filePath: string): boolean {
  return filePath.replace(/^\//, '').toLowerCase() === SPANISH_TRANSLATE_PAGE_PATH;
}
